<!-- <div>通话时长统计</div></div> -->
<template>
    <div class="fuzzy-matching-box">
      <div class="fuzzy-matching-top">
        <!-- <h1 class="titleStyle">通话时长统计</h1> -->
        <!-- <el-row class="top-first-line">
          <el-col :span="5">
              <el-form-item label="IMEI:">
                <el-input v-model="Dform.titleValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
          <el-col :span="5">
              <el-form-item label="姓名:">
                <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
          <el-col :span="5">
          </el-col >
          <el-col :span="5">
          </el-col >
    
        </el-row> -->
        <el-row class="top-first-line the-second-line">
          <el-col :span="5">
              <el-form-item label="IMEI:">
                <el-input v-model="Dform.titleValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
          <el-col :span="5">
              <el-form-item label="姓名:">
                <el-input v-model="Dform.schoolValue" placeholder=''></el-input>
              </el-form-item>
          </el-col >
            <el-col :span="5">
              <el-form-item label="开始时间:">
                <el-date-picker
                    v-model="Dform.startTime"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
          </el-col >
            <el-col :span="5">
              <el-form-item label="结束时间:">
                <el-date-picker
                    v-model="Dform.terminalTime"
                    type="datetime"
                    format="YYYY-MM-DD HH:mm:ss"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-col >
     
          <el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>
        </el-row>
      </div>
  
      <div class="fuzzy-matching-bottom">
        <el-row class="list">
          <el-table
            stripe
           :border="true"
           v-loading="loading"
           :header-cell-style="{background:'#EDF6FF',color:'#000',}"
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            class="table-Style"
            @selection-change="handleSelectionChange"
            @sort-change="sort_change">
           
            <el-table-column
              prop="name"
              label="姓名"
              >
            </el-table-column>
            <el-table-column
              prop="userName"
              label="所属单位"
              >
              <template #default="scope">
              <span v-if="scope.row.alias != null">{{scope.row.alias}}</span>
              <span v-else>{{scope.row.userName}}</span>
            </template>
            </el-table-column>
            <el-table-column
              prop="imei"
              label="IMEI"
              >
            </el-table-column>
            <el-table-column  
              prop="created"
              label="统计时长" 
              show-overflow-toolti 
              sortable>
                <!-- <template #header > 暂时无用
                    <span>统计时间</span>
                    <ArrowUp v-if="ArrowShow" style="width: 1em; height: 1em; margin-left: 3px;" @click="upwardClick" />
                    <ArrowDown v-if="!ArrowShow" style="width: 1em; height: 1em; margin-left: 3px;" @click="downwardClick" />
                </template>
                <template #default="scope">
                    <p>{{ scope.row.created }}</p>
                </template> -->
            </el-table-column>

            <el-table-column
              label="通话时长（秒）"
              show-overflow-tooltip>
              <template #default="scope">{{ scope.row.callTime  }}</template>
            </el-table-column>
            <el-table-column
              label="去电时长（秒）"
              show-overflow-tooltip>
              <template #default="scope">{{ scope.row.outTime  }}</template>
            </el-table-column>
            <el-table-column
              label="来电时长（秒）"
              show-overflow-tooltip>
              <template #default="scope">{{ scope.row.outTime }}</template>
            </el-table-column>
          </el-table>
          <div class="block-fenye" >
            <el-pagination
                :small="small"
                :disabled="disabled"
                :background="background"
                layout="prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
          </div>
        </el-row>
      </div>
    </div>
  </template>
  
  <script>
  import { 
    callDuration
  } from '@/assets/api/api'
  import { ArrowUp,ArrowDown } from "@element-plus/icons-vue"; // 图标
  export default {
    components: {
      ArrowUp,ArrowDown
    },         
    data () {
      return {
        loading:true,
        Dform: {
            titleValue: '',
            schoolValue: '',
            startTime : '',
            terminalTime: '',
        },
        ArrowShow: true ,
        matchTime: [],
        tableData: [],
        multipleSelection: [],
        reviseShow: false,
        LeadingInShow: false,
        pageInfo: {
          page: 1,
          pageSize: 10,
        },
        total: 0
      }
    },
    created() {
       this.callDurationClick()
    },
    methods: {
      inquiryClick( ) {
        this.callDurationClick()
      },
      callDurationClick () {
        let params = {
          endTime:this.Dform.terminalTime,
          startTime:this.Dform.startTime,
          imei:this.Dform.titleValue,
          name:this.Dform.schoolValue,
          page: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize,
          userId: JSON.parse(localStorage.getItem('user')).id,
        }
        callDuration(params).then((res)=> {
          this.tableData = res.data.data
          this.total = res.data.totalCount
          this.loading = false
        }).catch((err)=> {
            console.log(err);
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        console.log(this.multipleSelection,val,'this.multipleSelection');
      },
      //统计时长用的暂时无用
      // upwardClick () {
      //   console.log('向上');
      //   this.ArrowShow = false
      // },
      // downwardClick() {
      //   console.log('向下');
      //   this.ArrowShow = true
      // },
      handleSizeChange (val) {
        console.log(`${val} items pr page`)
      },
      handleCurrentChange (val) {
        this.pageInfo.page = val
        this.callDurationClick()
      },
     
    },
    filters: {
    }
  }
  </script>
  
  <style lang='scss' scoped>
  .fuzzy-matching-box {
    width: 100%;
    height:  95%;
    border-radius: 8px;
    .title-top {
    }
    .fuzzy-matching-top {
      height: 100px ;
      background-color: #fff;
      border-radius: 15px;
      display: flex;
      align-content: space-around;  
      align-items: center;
      

      .titleStyle{
        width: 25%;
        margin-left: 40px;
        font-size: 20px;
        font-weight: 700;
      }

        /deep/ {
          .el-input--small .el-input__wrapper{
              margin-right: 15px;
              border-radius: 15px
              ;
            }
          .el-select--small {
              width: 100%;

          }
          .el-form-item--small .el-form-item__label {
            width: 110px;
            text-align: right;
            height: 35px;
            line-height: 35px;     
            font-weight: 700;     
            font-size: 16px;
          }
          .el-form-item {
            width: 109%;
        
            margin-left: 15px;
          }
          .el-input {
            width: 100%;
            height: 35px;

          }
         
      }
      .the-second-line {
        margin-top: 15px;
        position: relative;
        .query-button {
          position: absolute;
          right: 30px;
          padding: 16px 24px;
          // background-color: #1BC896;
          border-radius: 15px;
        }
      }
      
    }
    
      /deep/ {
        .el-range-editor--small.el-input__wrapper {
            height: 35px;
            line-height: 35px;  
          

        
     
      }
    }
    .fuzzy-matching-bottom {
      // height: calc(100% - 170px);
      height: 85%;
      overflow: auto;
      position: relative;
      padding: 0px 20px;
      padding-top: 25px;
      margin-top: 15px;
      background-color: #fff;
      border-radius: 15px;
      .table-Style{
        font-size: 16px;
        // border-radius: 15px;
      }
      .top-first-line {
        height: 45px;
        line-height: 45px;
          /deep/ .tip-button {
            padding: 14px 14px;
            margin: 0px 3px;
          }
        .import-export-button {
          position: absolute;
          right: 20px;
          /deep/ .el-button--small {
            padding: 16px 24px;
            border: 1px solid #569CFF;
            color: #569CFF;
          }
        }
      }
      .list {
        position: relative;
        // margin-top: 10px;
        padding-bottom: 50px;
       .fenye {
        // float: right;
        text-align: center;
       }
        /deep/ {
          // .el-checkbox.el-checkbox--small .el-checkbox__inner {
          //   width: 18px;
          //   height: 18px;
          // }
          // .el-checkbox:last-of-type {
          //   margin-right: -1px;
          // }
          .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf {
            // border: 0px;
          }
          .el-table tr {
            height: 40px;
            cursor: pointer;
            font-size: 16px;
            color: black;
            user-select: initial;
           
          }
           .manipulate {
            color: red;
            margin-right:15px;
            cursor: pointer;
            // user-select: none;
          }
          .confirm,.duplicate,.revise {
            color:#1677FF;
            
          }
          .el-table th.el-table__cell>.cell {
            text-align: center;
            font-weight: 700;
          }
          .el-table td.el-table__cell, .fuzzy-matching-box .fuzzy-matching-bottom .list[data-v-1ddf37d1] .el-table th.el-table__cell.is-leaf {
            text-align: center;
          }
        }
        .block-fenye {
          // float: right;
          position: absolute;
          bottom: 0px;
          left: 50%;
          transform: translate(-50%,0);
          
        }
      }
    }
    
  }
  </style>